// Imports from external sources
// React, i18next, Router, Mantine, Further Stuff
import { 
    useTranslation
} from "react-i18next"

import {  
    useNavigate 
} from "react-router-dom"

import {
    Button
} from "@mantine/core"

// Imports from vseth-canine-ui


// Imports from this projects
// Pages, Components, Features, Hooks
import { 
    useAppDispatch 
} from "../../../hooks/useAppDispatch"

import { 
    deleteStorageUnitMessage 
} from "../../../features/storageunit/storageUnitSlice"


interface DeleteStorageUnitButtonProps {
    editStorageUnitId: number,
}


/**
 * The CancelButton component renders the admin page of the application.
 */
export const DeleteStorageUnitButton = (props: DeleteStorageUnitButtonProps) => {    
    const { t } = useTranslation()
    const navigate = useNavigate()    
    const dispatch = useAppDispatch()
    
   
    return (
        <Button
            color="red"
            onClick={() => {
                dispatch(deleteStorageUnitMessage(props.editStorageUnitId))
                navigate(-1)
            }}
            fullWidth
        >
            {t("Storeroom.deleteButton")}
        </Button>
    )
}